export default __webpack_public_path__ + "static/media/zachy.fe5b43eb.jpg";